import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


import { MaeAVCursosM,MaeAVParticipantesM } from '../model/mae-aulavirtual-bean';

import { Response_dml_bean,ResponseMensaje, MensajeServicioAD } from '../model/response-dml';

@Injectable({
  providedIn: 'root'
})

export class MaeAulaVirtualService {

  baseURL = environment.urlBase;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;

  constructor(private httpclient:HttpClient) {}

  getCategorias(c_tipo:string): Observable<MaeAVCursosM[]> {

    var url  : string;
    url = this.baseURL + 'aulavirtual/api/listarcategorias';

    let params = new HttpParams()
    .set('C_TIPO', c_tipo);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MaeAVCursosM[]>(url,  {headers:headers,params: params});
  }
  getCursos(categoria_id:string,c_tipo:string): Observable<MaeAVCursosM[]> {

    var url  : string;
    url = this.baseURL + 'aulavirtual/api/listarcursos';

    let params = new HttpParams()
    .set('C_CATEGORIA_ID', categoria_id)
    .set('C_TIPO', c_tipo);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MaeAVCursosM[]>(url,  {headers:headers,params: params});

  }

  getParticipantes(c_curso:string,c_tipo:string): Observable<MaeAVParticipantesM[]> {

    var url  : string;
    url = this.baseURL + 'aulavirtual/api/listarparticipantes';

    let params = new HttpParams()
    .set('C_CURSO', c_curso)
    .set('C_TIPO', c_tipo);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<MaeAVParticipantesM[]>(url,  {headers:headers,params: params});

  }

}
